// extracted by mini-css-extract-plugin
module.exports = {"spinner":"jgp-DpWJi"};